import { memo, useContext, useEffect, useRef } from 'react';
import AnimateTop from 'components/AnimateTop';
import Footer from 'components/footer/Footer';
import { FooterOkBtn, FooterPressText } from 'components/footer/Footer.styled';
import { Step6bWrapper, Step6Subtitle } from './Step6.styled';
import { nextStep, prevStep } from 'store/slices/global.slice';
import { useDispatch } from 'react-redux';
import { UserFormContext } from 'components/UserForm';
import BaseText from 'components/common/BaseText';
import DropZone from 'components/drop-zone/DropZone';

const Step6B = () => {
  const dispatch = useDispatch();

  const { insBack, setInsBack } = useContext(UserFormContext);

  const continueRef = useRef(null);

  useEffect(() => {
    if (continueRef.current) continueRef.current.focus();
  }, [continueRef]);

  return (
    <AnimateTop y={window.innerWidth < 768 ? '150px' : '100px'}>
      <Step6bWrapper>
        <Step6Subtitle>
          <BaseText type='big'>
            Please upload the back of your
            <span style={{ fontWeight: 600 }}> insurance card.</span>
          </BaseText>
          <span>b.</span>
        </Step6Subtitle>
        <DropZone data={insBack} setData={setInsBack} />
        <Footer
          nextArrowClick={() => dispatch(nextStep({ step: 63 }))}
          prevArrowClick={() => dispatch(prevStep({ step: 61 }))}
        >
          <FooterOkBtn
            onClick={() => dispatch(nextStep({ step: 63 }))}
            ref={continueRef}
          >
            Continue
          </FooterOkBtn>
          <FooterPressText>press Enter ↵</FooterPressText>
        </Footer>
      </Step6bWrapper>
    </AnimateTop>
  );
};

export default memo(Step6B);
